import { Amplify } from "aws-amplify"
import { CookieStorage } from "aws-amplify/utils"
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito"





const awsConfig = {
  Auth: {
    Cognito: {
      region: "ap-northeast-1",
      userPoolId: process.env.COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.USER_POOL_CLIENT_ID,
      storage: new CookieStorage({
        domain: process.env.COOKIE_DOMAIN || undefined,
        path: "/",
        expires: 365,
        secure:
          typeof window !== "undefined"
            ? window.location.protocol === "https:"
            : false,
        sameSite: "lax",
      }),
      loginWith: {
        username: true,
        email: false,
        phone: false,
      },
    },
  },
}

Amplify.configure(awsConfig)

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage())

export default awsConfig
